<template>
    <div ref="mo_root" class="mo_root" :style="pageRootStyle">
        <!-- tab 顶部导航 -->
        <div class="tab">
            <div class="logo" @click="onClickHome">
                <img src="../../static/pc/logo.png" alt="">
            </div>
            <div class="app_wrap">
                <div @click="onClickHome">
                    <img src="../../static/pc/top_btn_1.png" alt="">
                </div>
                <!-- <div @click="onClickGallery">
                    <img src="../../static/pc/top_btn_2.png" alt="">
                </div> -->
                <div @click="onClickFun">
                    <img src="../../static/pc/top_btn_fun.png" alt="">
                </div>
                <div v-if="wikiEnabled" @click="onClickCard">
                    <img src="../../static/pc/card.png" alt="">
                </div>
                <div @click="onClickComponent">
                        <img src="../../static/top_btn_discord.png" alt="">
                    </div>
            </div>
            <div class="btn_wrap">
                <div v-if="showGuide || showFun" class="top_btn_lang" ref="langBtn">
                    <div class="lang_trigger" @click="toggleLangPicker">
                        <img src="../../static/pc/top_btn_lang.png" alt="">
                    </div>
                    <div v-if="showLangPicker" class="lang_dropdown">
                        <div
                            v-for="opt in LANG_OPTIONS"
                            :key="opt.key"
                            class="lang_dropdown_item"
                            :class="{ active: lang === opt.key }"
                            @click="switchLang(opt.key)"
                        >{{ opt.label }}</div>
                    </div>
                </div>
                <div class="top_btn_steam" style="opacity: 0">
                    <img src="../../static/pc/top_btn_steam.png" alt="">
                </div>
            </div>
        </div>

        <!-- 图鉴内容 -->
        <GuidePc v-if="showGuide" :parent-lang="lang" />

        <!-- HABBY FUN 页面 -->
        <FunPc v-if="showFun" :parent-lang="lang" />

        <!-- 主页内容 -->
        <template v-if="!showGuide && !showFun">
            <!-- banner 首图 -->
            <div class="banner_wrap">
                <div class="title"> <img src="../../static/pc/title.png" alt=""> </div>
                <div class="banner_btn_wrap">
                    <div @click="onClickSteam" class="btn_Steam">
                        <img src="../../static/btn_Steam.png" alt="">
                    </div>
                    <!-- 临时 Discard -->
                    <!-- <div @click="onClickComponent" class="banner_btn">
                        <img src="../../static/Component.png" alt="">
                    </div> -->
                </div>
            </div>

            <!-- 分割线 -->
            <div class="segmentation">
                <img src="../../static/pc/segmentation.png" alt="">
            </div>

            <!-- swiper 轮播图 -->
            <div class="reference" ref="swiperSection">
                <img class="swiper_bg" src="../../static/pc/swiper_bg.png" alt="">

                <div class="swiper_wrap" ref="swiperContainer">
                    <img class="swiper_title" src="../../static/pc/swiper_title.png" alt="">
                    <div id="carousel" class="carousel">
                        <swiper v-if="swiperInitialized" :options="swiperOption" ref="mySwiper">
                            <swiper-slide v-for="(image, index) in images" :key="index">
                                <img class="slide_img" :src="image" :alt="'Image ' + (index + 1)">
                            </swiper-slide>
                            <div class="swiper-pagination" slot="pagination">
                            </div>
                        </swiper>
                        <div class="swiper_slide_bg">
                            <img src="../../static/pc/swiper_slide_bg.png" alt="">
                        </div>
                        <img class="carousel_prev" src="../../static/pc/prev.png" alt="" @click="swiperPrev">
                        <img class="carousel_next" src="../../static/pc/next.png" alt="" @click="swiperNext">
                    </div>
                </div>

                <img class="swiper_prev" src="../../static/pc/swiper_prev.png" alt="" @click="swiperPrev">
                <img class="swiper_next" src="../../static/pc/swiper_next.png" alt="" @click="swiperNext">
            </div>

        </template>

        <Footer></Footer>


        <!-- 视频弹窗 -->
        <VideoModal
            v-if="isShowVideo"
            :videoSrc="currentVideoSrc"
            @handleClose="handleCloseVideo"
        />

        <!-- 敬请期待提示 -->
        <transition name="toast-fade">
            <div v-if="showToast" class="coming-soon-toast">敬请期待～</div>
        </transition>
    </div>
</template>

<script>
import pcLogic from './index.js'
import VideoModal from '@/components/VideoModal.vue'
import GuidePc from './guide/GuidePc.vue'
import FunPc from './fun/FunPc.vue'
import { TGA } from '@/utils/tga'

export default {
    props: ['language'],
    components: {
        VideoModal,
        GuidePc,
        FunPc
    },
    mixins: [pcLogic],
    computed: {
        pageRootStyle() {
            if (this.showGuide) return { backgroundColor: '#ffecd8' };
            if (this.showFun) return { backgroundColor: '#000' };
            return {};
        },
    },
    mounted() {
        document.addEventListener('click', this.closeLangPicker);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeLangPicker);
    },
    methods: {
        toggleLangPicker() {
            this.showLangPicker = !this.showLangPicker;
        },
        closeLangPicker(e) {
            if (this.$refs.langBtn && !this.$refs.langBtn.contains(e.target)) {
                this.showLangPicker = false;
            }
        },
        onClickHome() {
            TGA.trackClick('Home');
            this.showGuide = false;
            this.showFun = false;
            this.scrollToTop();
        },
        onClickGallery() {
            TGA.trackClick('Gallery');
            this.scrollToSwiper();
        }
    }
}
</script>

<style scoped lang="less">
@import "./pc.less";

.coming-soon-toast {
    position: fixed;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.75);
    color: #fff;
    font-size: 24px;
    padding: 16px 40px;
    border-radius: 12px;
    z-index: 9999;
    pointer-events: none;
    letter-spacing: 2px;
}

.toast-fade-enter-active {
    transition: opacity 0.5s ease;
}
.toast-fade-leave-active {
    transition: opacity 1s ease;
}
.toast-fade-enter,
.toast-fade-leave-to {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/pc.vue